import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  refundContainer: {
    padding: theme.spacing(3),
    margin: "0 auto",
    alignItems: "center",
    alignContent: "center",
    justifyContent: "center"
  },
  innerContainer: {
    width: 420,
  },
  title: {
    marginBottom: theme.spacing(4),
    fontWeight: 400,
    textAlign: "left",
    paddingRight: theme.spacing(4),
  },
  value: {
    marginBottom: theme.spacing(3)
  },
  submitButton: {
    minWidth: 200,
    marginTop: theme.spacing(3)
  },
  refundSuccessful: {
    minWidth: 200,
    marginTop: theme.spacing(3),
    backgroundColor: "#4caf50",
    color: "#fff !important"
  },
  buttonRight: {
    margin: theme.spacing(2),
    float: "right",
    marginRight: 0,
  },
  warningAlert: {
    width: "100%",
    border: "1px solid",
    alignItems: "center",
  },
  buttonRow: {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    gap: theme.spacing(2)
  },
  centerAlign: {
    justifyContent: "center",
    display: "flex"
  }
}));